// 辞書の文言の {{name}} を置き換える（useDict と価格改定の useDictWithFormat が共有）。
// 空文字・"0" も値として入れる（`||` だと空文字がプレースホルダのまま画面に出る）。渡していない名前だけ {{name}} のまま残す。
export const applyDictReplacements = (str: string, replacements: { [key: string]: string }): string =>
  str.replace(/{{\s*(.*?)\s*}}/g, (_, p1: string) => replacements[p1] ?? `{{${p1}}}`);
